import { render, staticRenderFns } from "./DetalleEmergenciaHistorialSection.vue?vue&type=template&id=7859dbe8&scoped=true&"
import script from "./DetalleEmergenciaHistorialSection.vue?vue&type=script&lang=js&"
export * from "./DetalleEmergenciaHistorialSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7859dbe8",
  null
  
)

export default component.exports